import React, { useState, useEffect } from "react";

import * as APIModels from "../../../../models";
import { AttorneyService } from "../../../../services/ClientService";
import MaterialTable, {
    Column,
    EditComponentProps,
} from "@material-table/core";
import { useCallback } from "react";
import { Checkbox } from "@material-ui/core";

export default function PendingQueue({
    attorney,
}: {
    attorney: APIModels.Attorney;
}) {
    const [updatedAttorney, setUpdatedAttorney] = useState(attorney);
    const [saving, setSaving] = useState(false);
    const [retrieving, setRetrieving] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [data, setData] = useState([] as APIModels.CorrectionQueue[]);
    const [retrieveResult, setRetrieveResult] = useState("");

    useEffect(() => {
        setUpdatedAttorney(attorney);
    }, [attorney]);

    const onSaveClick = useCallback(async () => {
        setSaving(true);
        AttorneyService.savePendingQueue({
            attorneyId: attorney.id!,
            body: updatedAttorney,
        }).then(
            (resp) => {
                setSaving(false);
                if (resp.successful === true) {
                    setErrorMessage(resp.errorMessage ?? "");
                    attorney = { ...resp.data };
                } else {
                    console.log(resp.errorMessage);
                }
            },
            (error) => {
                setSaving(false);
                console.log(error);
                setErrorMessage("An error has occurred");
            }
        );
    }, [updatedAttorney]);

    const onDownLoadClick = () => {
        setRetrieveResult("");
        setRetrieving(true);
        AttorneyService.correctionQueue({
            attorneyId: attorney.id!,
        }).then(
            (resp) => {
                if (resp.successful === true && resp.data?.length != 0) {
                    setData(resp.data as APIModels.CorrectionQueue[]);
                } else if (resp.data?.length === 0) {
                    setRetrieveResult("No Records in Queue.");
                } else {
                    console.log(resp.errorMessage);
                }
                setRetrieving(false);
            },
            (error) => {
                setRetrieving(false);
                console.log(error);
                setRetrieveResult("An error has occurred");
            }
        );
    };

    return (
        <div className="card text-left">
            <div className="card-body">
                <h4 className="mb-3 bg-light p-2">Pending Queue</h4>
                <div className="row mb-3">
                    <div className="col-sm-4">
                        <label
                            htmlFor="txtProcessPendingQueue"
                            className="form-label"
                        >
                            Process Pending Queue
                        </label>
                        <div className="input-group">
                            <Checkbox
                                className="form-control"
                                id="txtProcessPendingQueue"
                                placeholder="PendingQueue"
                                aria-describedby="inputGroupPrepend"
                                checked={
                                    updatedAttorney.processPendingQueue ?? false
                                }
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        processPendingQueue:
                                            event.currentTarget.checked,
                                    })
                                }
                            />
                            <div className="invalid-feedback">
                                Please provide a valid first name.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <label
                            htmlFor="txtMonitorPendingQueue"
                            className="form-label"
                        >
                            Monitor Pending Queue
                        </label>
                        <div className="input-group">
                            <Checkbox
                                className="form-control"
                                id="txtMonitorPendingQueue"
                                placeholder="PendingQueue"
                                aria-describedby="inputGroupPrepend"
                                checked={
                                    updatedAttorney.monitorPendingQueue ?? false
                                }
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        monitorPendingQueue:
                                            event.currentTarget.checked,
                                    })
                                }
                            />
                            <div className="invalid-feedback">
                                Please provide a valid middle name.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <label
                            htmlFor="txtPendingQueueEmail"
                            className="form-label"
                        >
                            Pending Queue Email
                        </label>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtPendingQueueEmail"
                                placeholder="PendingQueueEmail"
                                aria-describedby="inputGroupPrepend"
                                value={updatedAttorney.pendingQueueEmail}
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        pendingQueueEmail:
                                            event.currentTarget.value,
                                    })
                                }
                            />
                            <div className="invalid-feedback">
                                Please provide a valid middle name.
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="text-end">
                        {saving ? (
                            <button
                                className="btn btn-success waves-effect waves-light mt-2"
                                type="submit"
                                disabled={true}
                            >
                                <span
                                    className="spinner-border spinner-border-sm me-1"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                                Saving...
                            </button>
                        ) : (
                            <button
                                className="btn btn-success waves-effect waves-light mt-2"
                                type="submit"
                                onClick={onSaveClick}
                            >
                                <i className="mdi mdi-content-save ml-1 me-1">
                                    {" "}
                                </i>
                                Save
                            </button>
                        )}
                        <div>{errorMessage}</div>
                    </div>
                </div>
                <div className="text-center">
                    {retrieving ? (
                        <button
                            className="btn btn-primary btn-rounded mt-3"
                            type="submit"
                            disabled={true}
                        >
                            <span
                                className="spinner-border spinner-border-sm me-1"
                                role="status"
                                aria-hidden="true"
                            ></span>
                            Retrieving...
                        </button>
                    ) : (
                        <button
                            className="btn btn-primary btn-rounded mt-3"
                            type="button"
                            onClick={onDownLoadClick}
                        >
                            <span>
                                {" "}
                                <i className="ri-download-2-line me-1"></i>
                                Retrieve Correction Queue
                            </span>
                        </button>
                    )}
                    <div>{retrieveResult}</div>
                </div>
            </div>
            <div className="card text-center">
                <div className="card-body">
                    <div style={{ maxWidth: "100%", zIndex: -1 }}>
                        <MaterialTable
                            columns={[
                                {
                                    title: "UCN",
                                    field: "ucn",
                                },
                                {
                                    title: "Case Title",
                                    field: "caseTitle",
                                },
                                {
                                    title: "Case Number",
                                    field: "caseNumber",
                                },
                                {
                                    title: "Reference Number",
                                    field: "referenceNumber",
                                },
                                {
                                    title: "Notes",
                                    field: "notes",
                                },
                            ]}
                            data={data}
                            title="Correction Queue"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
